import { render } from "./3BeMindful.vue?vue&type=template&id=42144ca8"
import script from "./3BeMindful.vue?vue&type=script&lang=js"
export * from "./3BeMindful.vue?vue&type=script&lang=js"
script.render = render

export default script